<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>智能柜列表</b></p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button round type="primary" @click="openDialog">添加智能柜</el-button>
                <span>-</span>
            </p>
        </div>

        <el-table :data="cabinetList" style="width: 100%">
            <el-table-column prop="cabinetCode" label="编号" width="300">
            </el-table-column>
            <el-table-column prop="cabinetName" label="名称" width="300">
            </el-table-column>

            <el-table-column prop="stuff" label="已绑刀具" width="500">
            </el-table-column>

            <el-table-column prop="statusDes" label="状态" width="200">
            </el-table-column>

            <el-table-column prop="macAddress" label="mac地址" v-if="false">
            </el-table-column>
            <el-table-column prop="ipAddress" label="ip地址" v-if="false">
            </el-table-column>

            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">

                    <el-button @click="bindClick(scope.row)" type="success" round size="small">
                        绑定刀具
                    </el-button>

                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        编辑
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="详情" :visible.sync="dialogFormVisible" width="25%">
            <el-form :model="form" :rules="rules" class="demo-ruleForm" ref="ruleForm">
                <el-form-item label="编号" :label-width="formLabelWidth" prop="cabinetCode">
                    <el-input v-model="form.cabinetCode" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="名称" :label-width="formLabelWidth" prop="cabinetName">
                    <el-input v-model="form.cabinetName" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>

                <el-form-item label="mac地址" :label-width="formLabelWidth">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span><el-input v-model="form.macAddress" autocomplete="off"
                        style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="ip地址" :label-width="formLabelWidth">
                    &nbsp;<el-input v-model="form.ipAddress" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="checkCabinet('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="刀具绑定" :visible.sync="dlgTableVisible">
            <el-table :data="cutterList">
                <el-table-column property="cutterCode" label="编号" width="200"></el-table-column>
                <el-table-column property="cutterName" label="名称" width="150"></el-table-column>

                <el-table-column property="quantity" label="数量" width="220"></el-table-column>

                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="bindOrNoClick(scope.row)" type="text" size="small" style="color:green">{{
                    scope.row.stuffId == null ? '绑定' : '取消绑定'
                }}</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div>
                <el-pagination background :page-size="cutPgNum" :page-count="pageCount"
                    layout="total, sizes, prev, pager, next" :total="cutTotal" @current-change="pageClick"
                    :page-sizes="[8, 10, 12, 14]" @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </el-dialog>

    </div>
</template>

<script>

export default {
    name: "SmartCabinet",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            cabinetList: [],

            dialogFormVisible: false,

            form: {
                id: '',
                cabinetCode: '',
                cabinetName: '',
                macAddress: '',
                ipAddress: '',
                status: ''
            },
            stuffId: null,
            rules: {
                cabinetCode: [{
                    required: true, message: '请输入编号', trigger: 'blur'
                }],
                cabinetName: [{
                    required: true, message: '请输入名称', trigger: 'blur'
                }]
            },

            cutPgIndex: 0,
            cutPgNum: 5,
            cutTotal: 0,
            dlgTableVisible: false,
            cutterList: []
        }
    },
    methods: {
        //绑定刀具按钮点击事件
        bindClick(row) {
            this.form.id = row.id

            this.form.cabinetCode = null
            this.form.cabinetName = null
            this.form.macAddress = null
            this.form.ipAddress = null

            this.getAllCutterBase(row)
        },
        bindOrNoClick(row) {

            if (row.stuffId == null) {
                this.bindCutter(row)
            } else {
                this.unBindCutter(row)
            }
        },
        bindCutter(row) {

            this.stuffId = row.id

            this.addCabinet()
        },
        unBindCutter(row) {
            this.stuffId = ''

            this.addCabinet()
        },
        getAllCutterBase() {
            this.$axios({
                method: "post",
                url: "/shiro/base/cutter/getAll",
                data: {
                    pageIndex: this.cutPgIndex,
                    pageNum: this.cutPgNum,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.cutterList = data.data
                this.cutTotal = this.cutterList[0].total

                this.dlgTableVisible = true
            })
        },
        openDialog() {
            this.form.id = ''

            this.form.cabinetCode = ''
            this.form.cabinetName = ''
            this.form.macAddress = ''
            this.form.ipAddress = ''

            this.stuffId = null
            this.dialogFormVisible = true
        },
        addCabinet() {
            this.$axios({
                method: "post",
                url: "/shiro/cabinet/add",
                data: {
                    id: this.form.id,
                    cabinetCode: this.form.cabinetCode,
                    cabinetName: this.form.cabinetName,
                    macAddress: this.form.macAddress,
                    ipAddress: this.form.ipAddress,
                    status: this.form.status,
                    stuffId:this.stuffId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 201) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                }

                this.dlgTableVisible=false
                this.getAll()

            })
        },
        checkCabinet(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //alert('submit!');
                    this.addCabinet()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })

        },
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/cabinet/getAll",
                data: {
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.cabinetList = data.data
                for (let i in this.cabinetList) {
                    if (this.cabinetList[i].status == 0) {
                        this.cabinetList[i].statusDes = '关'
                    } else if (this.cabinetList[i].status == 1) {
                        this.cabinetList[i].statusDes = '开'
                    }
                }

                if (this.dialogFormVisible) {
                    this.dialogFormVisible = false
                }

            })
        },
        handleClick(row) {
            this.form.id = row.id

            this.dialogFormVisible = true
            this.form.cabinetCode = row.cabinetCode
            this.form.cabinetName = row.cabinetName
            this.form.macAddress = row.macAddress
            this.form.ipAddress = row.ipAddress
            this.form.status = row.status
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeCabinet(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        removeCabinet(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/cabinet/remove",
                data: {
                    id: row.id,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAll()
            })
        }
    },
    mounted() {
        this.getAll()
    }
}
</script>